import { createSelector } from "reselect"
import { KEY } from "./constants"
import { initialState } from "./reducer"

export const getToastsState = state => state.get(KEY, initialState)

export const makeSelectToasts = () =>
  createSelector(getToastsState, state => state.get("toastList").toJS())
